import React from "react";
import { getOverview } from "../api/services";
import { useData } from "../hooks/useData";
import { KpiCard, Card, Loading } from "../components/common/UI";
import WeeklyBurnUp from "../components/charts/WeeklyBurnUp";
import PlanFactTable from "../components/common/PlanFactTable";
import { fmtKop, fmtNum, fmtPct } from "../utils/format";
import styles from "./pages.module.css";

export default function Overview() {
  const { data, loading } = useData(getOverview, []);
  if (loading || !data) return <Loading />;

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1 className={styles.pageTitle}>Обзор</h1>
          <div className={styles.pageSub}>
            Движение к цели 1 млн ₽/мес за 4 месяца акселерации (июль–октябрь)
          </div>
        </div>
      </div>

      <div className={styles.kpiGrid}>
        <KpiCard label="MRR текущего месяца" value={fmtKop(data.current_mrr_kop, { short: true })} />
        <KpiCard
          label="Цель (месячный MRR)"
          value={fmtKop(data.target_mrr_kop, { short: true })}
          sub={`Достигнуто: ${fmtPct(data.pct_to_goal)}`}
          accent="var(--accent)"
        />
        <KpiCard
          label="Недель до конца октября"
          value={data.weeks_left ?? "—"}
          sub={data.required_weekly_kop ? `Нужно +${fmtKop(data.required_weekly_kop, { short: true })}/нед` : ""}
        />
        <KpiCard label="Аккаунтов в экосистеме" value={fmtNum(data.accounts_total)} />
      </div>

      <Card title="Путь к цели по неделям (план и факт)">
        <WeeklyBurnUp weekly={data.weekly} target={data.target_mrr_kop} />
      </Card>

      <Card title="План и факт по месяцам акселерации">
        <PlanFactTable
          rows={data.monthly}
          labelKey="name"
          labelTitle="Месяц"
        />
      </Card>

      <Card title="План и факт по неделям">
        <PlanFactTable
          rows={data.weekly}
          labelKey="week_label"
          labelTitle="Неделя"
          futureKey="is_future"
        />
      </Card>
    </div>
  );
}
